<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Add`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_b58c7549c0__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_b58c7549c0__a)"><path d="M22.4,25.6L22.4,39.4C22.4,40.2837,23.1164,41,24,41C24.8836,41,25.6,40.2837,25.6,39.4L25.6,25.6L39.4,25.6C40.2837,25.6,41,24.8837,41,24C41,23.1163,40.2837,22.4,39.4,22.4L25.6,22.4L25.6,8.59998C25.6,7.716331,24.8836,7,24,7C23.1164,7,22.4,7.716331,22.4,8.59998L22.4,22.4L8.60001,22.4C7.716347,22.4,7,23.1163,7,24C7,24.8837,7.716347,25.6,8.60001,25.6L22.4,25.6Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconAdd',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
